// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.documents.LeaseDocumentsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetExplainerLeaseForLeaseResponseDto,
  GetLandlordProvidedDocumentsResponseDto,
  LeaseArtifactType,
  PreviewUrlResponseDto,
} from '../..';

interface GetExplainerLeaseForLeaseParams {
  leaseId: number;
}
interface GetLandlordProvidedDocumentsParams {
  leaseId: number;
}
interface PreviewUrlParams {
  excludeAttachments?: boolean;
  leaseArtifactId: number;
  leaseArtifactType: LeaseArtifactType;
}

export const LeaseDocumentsWebApiHandler_getExplainerLeaseForLease_Path =
  '/api/web/v1/documents/getExplainerLeaseForLease';

/**
 * get explainer lease file name associated with specific lease
 */
export const LeaseDocumentsWebApiHandler_getExplainerLeaseForLease = (
  getParams: GetExplainerLeaseForLeaseParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetExplainerLeaseForLeaseParams, never, GetExplainerLeaseForLeaseResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseDocumentsWebApiHandler_getExplainerLeaseForLease_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments_Path =
  '/api/web/v1/documents/getLandlordProvidedDocuments';

/**
 * get landlord provided document names
 */
export const LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments = (
  getParams: GetLandlordProvidedDocumentsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetLandlordProvidedDocumentsParams, never, GetLandlordProvidedDocumentsResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseDocumentsWebApiHandler_previewUrl_Path = '/api/web/v1/documents/previewUrl';

/**
 * get preview lease url
 */
export const LeaseDocumentsWebApiHandler_previewUrl = (getParams: PreviewUrlParams, client = getClient()) => {
  return httpFrontEndRequest<PreviewUrlParams, never, PreviewUrlResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseDocumentsWebApiHandler_previewUrl_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
